

/* BEGIN riding-running-waist-bag-buyer-highlights-20260731 */
;(function () {
  var expected = ["Water-resistant 900D polyester, a military-standard SBS zipper, and a secure KAM buckle provide durable construction for riding, running, and everyday carry.","MOLLE webbing expands attachment options for compact gear and accessories.","A hook-and-loop patch area supports easy personalization with compatible patches."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-riding-running-waist-bag-multi-function-chest-bag') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END riding-running-waist-bag-buyer-highlights-20260731 */
